import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enAuth from './locales/en/auth.json';
import enCommon from './locales/en/common.json';
import enDashboard from './locales/en/dashboard.json';
import enErrors from './locales/en/errors.json';

import frAuth from './locales/fr/auth.json';
import frCommon from './locales/fr/common.json';
import frDashboard from './locales/fr/dashboard.json';
import frErrors from './locales/fr/errors.json';

import enSidebar from './locales/en/sidebar.json';
import enSupport from './locales/en/support.json';
import frSidebar from './locales/fr/sidebar.json';
import frSupport from './locales/fr/support.json';

import enAccount from './locales/en/account.json';
import frAccount from './locales/fr/account.json';

import enSubscription from './locales/en/subscription.json';
import frSubscription from './locales/fr/subscription.json';

import enNewConversation from './locales/en/newconversation.json';
import frNewConversation from './locales/fr/newconversation.json';

import enConversation from './locales/en/conversation.json';
import frConversation from './locales/fr/conversation.json';

import enDatePlanning from './locales/en/datePlanning.json';
import frDatePlanning from './locales/fr/datePlanning.json';

import enLanding from './locales/en/landing.json';
import frLanding from './locales/fr/landing.json';

const resources = {
  en: {
    auth: enAuth,
    common: enCommon,
    dashboard: enDashboard,
    errors: enErrors,
    sidebar: enSidebar,
    support: enSupport,
    account: enAccount,
    subscription: enSubscription,
    newconversation: enNewConversation,
    conversation: enConversation,
    datePlanning : enDatePlanning,
    landing: enLanding
  },
  fr: {
    auth: frAuth,
    common: frCommon,
    dashboard: frDashboard,
    errors: frErrors,
    sidebar: frSidebar,
    support: frSupport,
    account: frAccount,
    subscription: frSubscription,
    newconversation: frNewConversation,
    conversation: frConversation,
    datePlanning : frDatePlanning,
    landing: frLanding,
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    lng: localStorage.getItem('language') || 'en',
    defaultNS: 'common',
    ns: ['auth', 'common', 'dashboard', 'sidebar', 'support', 'subscription','newconversation', 'conversation','datePlanning' , 'errors', 'account','landing'],
    debug: true,
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'language',
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    }
  });

export default i18n;